import * as ng from 'angular';
import {UISelectService} from '../../../../../services/ui-select.service';
import {ArchiSmallServices} from '../../../../../services/archismall.service';
import {CountryCodesService} from '../../../../../services/data/country-codes.service';
import {diff} from 'deep-object-diff';
import {IUser} from '../../../../../commons/interfaces/user/user';
import {IInvoices} from '../../../../../commons/interfaces/user/invoices';
import {IListini, IProfile} from '../../../../../commons/interfaces/listini';
import {FileService} from '../../../../../services/file.service';
import {STORAGE_BUCKET} from '../../../../../config';
import {IRivenditore} from '../../../../../commons/interfaces/IRivenditore';
import {IStorageUsageStatistics} from '../../../../../commons/interfaces/storageUsageStatistics';
import {IStorageUsageClassDocStatistics} from '../../../../../commons/interfaces/storageUsageClassDocStatistics';
import {appContext} from '../../../../../app.context';
import {saveAs} from '../../../../../third/fileSaver';
import {IStorageArchiviaUser} from '../../../../../commons/interfaces/IStorageUsageUser';

interface IDati {
  email: string;
  firstName: string;
  lastName: string;
  fiscalCode: string;
  piva: string;
  cf: string;
  ragione_sociale: string;
  nome: string;
  cognome: string;
  codice: string;
  data_nascita_rf: Date;
  dsExpireDate: Date;
}

// stessa Classe enum da archivist.archismall.util.enums per i tipi di limite
const Limit = {
  FE: 'FE',
  CE: 'CE',
  PEC: 'PEC',
};

const ActivationCode = {
  PROFILE: '',
  RESELLER: '',
  FE: '',
  CE: '',
  COD_RANDOM: '',
};

class ModificaClienteController implements ng.IController {

  static $inject: string[] = [
    '$scope',
    '$rootScope',
    '$state',
    '$http',
    'configuration',
    'store',
    'jwtHelper',
    '$uibModal',
    'ArchiSmallServices',
    '$sce',
    '$stateParams',
    '$filter',
    'UiSelectService',
    'CountryCodesService',
    'FileService'
  ];
  private countriesCodeValues: Record<string, string>;

  constructor(
    private $scope: {
      pageHeader: string,
      pageSubHeader: string,
      dati: IDati,
      user: IUser,
      originalUser: IUser,
      fatture: IInvoices[],
      yearsFatture: number[],
      consumi: IStorageUsageStatistics[],
      consumoTotale: number,
      consumiPec: IStorageUsageClassDocStatistics[],
      classDocPec: IStorageUsageClassDocStatistics[],
      consumoTotalePec: number,
      scadenza: { value: Date },
      can_use_fatturazione: boolean,
      can_use_conservazione: boolean,
      solo_consultazione: boolean,
      dataAttivazione: string,
      dataCancellazione: string,
      sedeStates: string[],
      cities: string[],
      listini: IListini[],
      listino: IListini,
      codProfiloFE: IProfile,
      codProfiloCE: IProfile,
      codProfiloPEC: IProfile
      profiloFE: IProfile,
      profiloCE: IProfile,
      profiloPEC: IProfile,
      rivenditori: IRivenditore[],
      storageCE: string,
      spaceArchivia: IStorageArchiviaUser[],
      consumiArchiviaList: IStorageArchiviaUser[];
      consumiArchivia: number,
      archidriveUsed: number,
      currentYear: number,
      isEmailSentThresholdSurpassedCE: boolean,
      isEmailSentThresholdSurpassedFE: boolean,
      isEmailSentThresholdSurpassedPEC: boolean,
      isEmailSentLimitSurpassedCE: boolean,
      isEmailSentLimitSurpassedFE: boolean,
      isEmailSentLimitSurpassedPEC: boolean,

      consumiArchiviaCurrentYear: number,
      [key: string]: any
    },
    private $rootScope: any,
    private $state: any,
    private $http: ng.IHttpService,
    private configuration: any,
    private store: ng.a0.storage.IStoreService,
    private jwtHelper: any,
    private $uibModal: ng.ui.bootstrap.IModalService,
    private ArchiSmallServices: ArchiSmallServices,
    private $sce: ng.ISCEService,
    private $stateParams: ng.ui.IStateParamsService,
    private $filter: ng.IFilterService,
    private UISelectService: UISelectService,
    private countryCodesService: CountryCodesService,
    private fileService: FileService
  ) {
    $scope.pageHeader = 'Modifica Cliente';
    $scope.pageSubHeader = '';
    $scope.user = undefined;
    $scope.consumi = undefined;
    $scope.consumoTotale = 0;
    $scope.scadenza = {value: undefined};
    $scope.can_use_fatturazione = false;
    $scope.can_use_conservazione = false;
    $scope.solo_consultazione = false;
    $scope.dataAttivazione = undefined;
    $scope.dataCancellazione = undefined;
    $scope.fatture = [];
    $scope.dati = {
      piva: undefined,
      cf: undefined,
      ragione_sociale: undefined,
      email: undefined,
      nome: undefined,
      cognome: undefined,
      codice: undefined,
      data_nascita_rf: undefined,
      dsExpireDate: undefined,
      firstName: undefined,
      lastName: undefined,
      fiscalCode: undefined
    };

    $scope.currentYear = (new Date()).getFullYear();

    const monthNames = [
      'A', // gennaio
      'B', // febbraio
      'C', // marzo
      'D', // aprile
      'E', // maggio
      'H', // giugno
      'L', // luglio
      'M', // agosto
      'P', // settembre
      'R', // ottobre
      'S', // novembre
      'T'  // dicembre
    ];


    $rootScope.formsubmitted = false;

    $scope.fiscalCodeType = new RegExp('^(?:[A-Z][AEIOU][AEIOUX]|[AEIOU]X{2}|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}(?:[\\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[15MR][\\dLMNP-V]|[26NS][0-8LMNP-U])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM]|[AC-EHLMPR-T][26NS][9V])|(?:[02468LNQSU][048LQU]|[13579MPRTV][26NS])B[26NS][9V])(?:[A-MZ][1-9MNP-V][\\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$');

    $scope.dpOpened = {
      periodStart: false,
      periodEnd: false,
      birthDate: false,
      dataIscrizioneAlbo: false
    };

    $scope.openDP = ($event, opened) => {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };
    $scope.autoOpen = ($event, opened) => {

      // tslint:disable-next-line:no-string-literal
      if (appContext.userBrowser['isIE']) {
        return;
      }
      $event.preventDefault();
      $event.stopPropagation();
      $scope.dpOpened[opened] = true;
    };

    $scope.trustAsHtml = (value) => {
      return $sce.trustAsHtml(value);
    };

    $scope.checkFiscalCodeBirthDate = () => {

      // logica check codiceFiscale con dataNascita
      if ($scope.originalUser.organizationData.responsabileConservazione !== undefined && $scope.originalUser.organizationData.responsabileConservazione.birthDate !== undefined) {

        const subStrCodFiscalYear = $scope.originalUser.organizationData.responsabileConservazione.fiscalCode.slice(6, 9);
        const subStrCodFiscalDay = $scope.originalUser.organizationData.responsabileConservazione.fiscalCode.slice(9, 11);
        const fiscalCodeMounth = monthNames[new Date(Date.parse($scope.originalUser.organizationData.responsabileConservazione.birthDate)).getMonth()];
        const fiscalCodeYear = new Date(Date.parse($scope.originalUser.organizationData.responsabileConservazione.birthDate)).getFullYear().toString().slice(2, 4);
        const fiscalCodeDay = new Date(Date.parse($scope.originalUser.organizationData.responsabileConservazione.birthDate)).getDate().toString().padStart(2, '0');

        if (parseInt(subStrCodFiscalDay, 10) > 40) {
          let subStrCodeCheckGender = (parseInt(subStrCodFiscalDay, 10) - 40).toString();
          let fiscalCodeBirthDateValid = (subStrCodFiscalYear.concat(subStrCodeCheckGender) === fiscalCodeYear.concat(fiscalCodeMounth).concat(fiscalCodeDay));
          $scope.form.birthDateResponConserv.$setValidity('fiscalCodeMismatch', fiscalCodeBirthDateValid);
          return $scope.form.birthDateResponConserv.fiscalCodeMismatch = !fiscalCodeBirthDateValid;
        } else {
          let fiscalCodeBirthDateValid = (subStrCodFiscalYear.concat(subStrCodFiscalDay) === fiscalCodeYear.concat(fiscalCodeMounth).concat(fiscalCodeDay));
          $scope.form.birthDateResponConserv.fiscalCodeMismatch = !fiscalCodeBirthDateValid;
          $scope.form.birthDateResponConserv.$setValidity('fiscalCodeMismatch', fiscalCodeBirthDateValid);
          return $scope.form.birthDateResponConserv.fiscalCodeMismatch;
        }
      }
      $scope.form.birthDateResponConserv.fiscalCodeMismatch = false;
    };

    // tutta la parte modificabile deve andare qui dalla pagina del cliente (motivi burocratici)
    this.countriesCodeValues = countryCodesService.getCountryCodes();
    $scope.refreshSedeStates = () => {
      let country = $scope.user.organizationData.codicePaese;
      ArchiSmallServices.getTypeaheadValues('state', `country=${country}`)
        .then((response) => {
          $scope.sedeStates = JSON.parse(JSON.stringify(response)) as string[];
        }, (error) => {
          console.error('error', error);
        });
    };
    $scope.refreshCities = () => {
      let country = $scope.user.organizationData.codicePaese;
      let state = $scope.user.organizationData.province;
      ArchiSmallServices.getTypeaheadValues('municipality', `country=${country}&state=${state}`)
        .then((response) => {
          $scope.cities = JSON.parse(JSON.stringify(response)) as string[];
        }, (error) => {
          console.error('error', error);
        });
    };
    $scope.sedeStates = [];
    $scope.cities = [];

    $scope.getUsersTypeaheadValues = () => {
      const emailcli = localStorage.getItem('mod_cli_email');

      ArchiSmallServices.getStorageArchive(emailcli, [])
        .then((response) => {
          $scope.spaceArchivia = JSON.parse(JSON.stringify(response)) as IStorageArchiviaUser[];
          if ($scope.spaceArchivia.length > 0) {
            const currentYearArchivia = $scope.spaceArchivia.filter(item => item.year === $scope.currentYear);
            if (currentYearArchivia.length > 0) {
              $scope.consumiArchiviaCurrentYear = Number(((currentYearArchivia[0].size) / Math.pow(1024, 2)).toFixed(2));
            }
            $scope.consumiArchiviaList = $scope.spaceArchivia.sort(({year: a}, {year: b}) => b - a);
            $scope.consumiArchivia = Number((($scope.consumiArchiviaList.reduce((prev, curr) => curr.size + prev, 0)) / (Math.pow(1024, 2))).toFixed());
          } else {
            $scope.consumiArchiviaList = [];
            $scope.consumiArchivia = 0;
          }
        });

      ArchiSmallServices
        .getStorageUsageCeYears(emailcli, [])
        .then(response => {
          $scope.consumiConservazioneBE = (JSON.parse(JSON.stringify(response)) as IStorageUsageStatistics[]);
          if ($scope.consumiConservazioneBE.length > 0) {
            const currentYearData = $scope.consumiConservazioneBE.filter((item: {
              year: any;
            }) => item.year === $scope.currentYear);
            if (currentYearData.length > 0) {
              let consumiConservazionecCurrentYearAppoggio = ((currentYearData[0].storageUsageInBytes) / Math.pow(1024, 2)).toFixed(2);
              if ($scope.consumiArchiviaCurrentYear !== undefined && $scope.consumiArchiviaCurrentYear !== null) {
                $scope.consumiConservazionecCurrentYear = (parseFloat(consumiConservazionecCurrentYearAppoggio) + $scope.consumiArchiviaCurrentYear).toFixed(2);
              } else {
                $scope.consumiConservazionecCurrentYear = ((parseFloat(consumiConservazionecCurrentYearAppoggio)));
              }
            }
            $scope.consumiConservazioneList = $scope.consumiConservazioneBE.sort(({year: a}, {year: b}) => b - a);
            $scope.consumiConservazione = (($scope.consumiConservazioneList.reduce((prev, curr) => curr.storageUsageInBytes + prev, 0)) / (Math.pow(1024, 2))).toFixed(2);
          } else {
            $scope.consumiConservazioneList = [];
            $scope.consumiConservazione = 0;
          }

          if ($scope.yearsFatture === undefined || $scope.yearsFatture.length === 0) {
            $scope.yearsList = $scope.consumiConservazioneList
              .map((item => item.year))
              .sort((a, b) => b - a)
              .filter((v, i, a) => {
                // rimuove duplicati
                return a.indexOf(v) === i;
              });
          } else {
            $scope.yearsList = $scope.yearsFatture.concat(...$scope.consumiConservazioneList
              .map((item => item.year)))
              .sort((a, b) => b - a)
              .filter((v, i, a) => {
                // rimuove duplicati
                return a.indexOf(v) === i;
              });
          }

        }).catch(err => {
        console.error(err);
      });

      ArchiSmallServices
        .getUser(emailcli)
        .then(response => {
          $scope.originalUser = JSON.parse(JSON.stringify(response)) as IUser;
          $scope.user = JSON.parse(JSON.stringify(response)) as IUser;
          $scope.scadenza.value = new Date($scope.user.subscription.subscriptionEnd);
          $scope.can_use_fatturazione = $scope.user.canUseFatturaPA;
          $scope.can_use_conservazione = $scope.user.canUseConservazione;
          $scope.solo_consultazione = !$scope.can_use_fatturazione && !$scope.can_use_conservazione;
          $scope.dataAttivazione = new Date($scope.user.subscription.subscriptionStart).toLocaleDateString();
          $scope.dataCancellazione = new Date($scope.user.subscription.subscriptionCancelledDate).toLocaleDateString();
          // check limit
          $scope.isEmailSentThresholdSurpassedCE = $scope.user.emailSentThresholdSurpassed.CE;
          $scope.isEmailSentThresholdSurpassedFE = $scope.user.emailSentThresholdSurpassed.FE;
          $scope.isEmailSentThresholdSurpassedPEC = $scope.user.emailSentThresholdSurpassed.PEC;
          $scope.isEmailSentLimitSurpassedCE = $scope.user.emailSentLimitSurpassed.CE;
          $scope.isEmailSentLimitSurpassedFE = $scope.user.emailSentLimitSurpassed.FE;
          $scope.isEmailSentLimitSurpassedPEC = $scope.user.emailSentLimitSurpassed.PEC;
          // utenza
          $scope.dati.email = $scope.user.accountData.email;
          $scope.dati.firstName = $scope.user.accountData.firstName;
          $scope.dati.lastName = $scope.user.accountData.lastName;
          $scope.dati.fiscalCode = $scope.user.accountData.fiscalCode;
          // rappresentante Legale
          $scope.dati.piva = $scope.user.organizationData.PIVA;
          $scope.dati.cf = $scope.user.organizationData.fiscalCode;
          $scope.dati.ragione_sociale = $scope.user.organizationData.name;
          $scope.dati.nome = $scope.user.organizationData.contactPerson.firstname;
          $scope.dati.cognome = $scope.user.organizationData.contactPerson.surname;
          $scope.dati.codice = $scope.user.subscription.activationCode;
          $scope.dati.data_nascita_rf = new Date($scope.user.organizationData.contactPerson.birthDate);
          // responsabile Conservazione
          if ($scope.user.organizationData.responsabileConservazione !== undefined && $scope.user.organizationData.responsabileConservazione.birthDate !== undefined) {
            $scope.originalUser.organizationData.responsabileConservazione.birthDate = $rootScope.formatDateValue($scope.user.organizationData.responsabileConservazione.birthDate);
          }
          $scope.dati.dsExpireDate = new Date($scope.user.digitalSign ? $scope.user.digitalSign.expireDate : null);

          ArchiSmallServices.getListini().then(response => {
              const listini = JSON.parse(JSON.stringify(response)) as IListini[];

              // tutti i listini;
              $scope.listini = listini.sort((a, b) => a.name.localeCompare(b.name));

              // listino singolo
              $scope.listino = listini.find(item => item._id === $scope.user.licenseProfile.licenseId);

              // visualizza i limiti Codici
              if ($scope.user.licenseProfile.profileCode !== undefined) {
                const limits = [Limit.CE, Limit.FE, Limit.PEC];
                limits.forEach(limit => {
                  const profileCode = $scope.user.licenseProfile.profileCode[limit];
                  if (profileCode !== undefined) {
                    $scope[`limitProfile${limit}`] = profileCode.limit;
                    $scope[`codProfilo${limit}`] = profileCode;
                  }
                });
              }
            }
          );

          if (!$scope.user.reseller || $scope.user.reseller) {
            ArchiSmallServices.getRivenditori().then(res => {
              $scope.rivenditori = JSON.parse(JSON.stringify(res)) as IRivenditore[];
              $scope.rivenditori.sort((a, b) => a.name.localeCompare(b.name));
              ActivationCode.RESELLER = $scope.dati.codice.split('-')[1];
              $scope.user.reseller = $scope.rivenditori.filter(riv => riv.code === ActivationCode.RESELLER ? ActivationCode.RESELLER : '')[0];
            });
          }
          const richieste = $scope.user.accountData.oldEmails && $scope.user.accountData.oldEmails.length ? $scope.user.accountData.oldEmails.map(email => {
            return ArchiSmallServices.getInvoices(email, []);
          }) : [];

          richieste.unshift(ArchiSmallServices.getInvoices(emailcli, []));

          function myPromiseFatture() {

            return Promise.all(richieste).then(res => {

              $scope.fatture = res
                .map(response => {
                  return JSON.parse(JSON.stringify(response)) as IInvoices[];
                })
                .reduce((acc, curr, index) => {

                  if (index === 0) {
                    return curr;
                  }
                  // serve per avere tutti gli anni possibili nell-array per sommare le fatture dopo
                  const years = acc.map(a => a.year)
                    .concat(...curr.map(c => c.year))
                    .filter((v, i, a) => {
                      // rimuove duplicati
                      return a.indexOf(v) === i;
                    });
                  $scope.yearsFatture = years;

                  return years.map(year => {
                    const a = acc.find(a => a.year === year);
                    const c = curr.find(c => c.year === year);
                    const fatture_sent = (a && a.invoicesSent || 0) + (c && c.invoicesSent || 0);
                    const fatture_received = (a && a.invoicesReceived || 0) + (c && c.invoicesReceived || 0);
                    return {...a, ...c, invoicesReceived: fatture_received, invoicesSent: fatture_sent} as IInvoices;
                  });
                })
                .sort(({year: a}, {year: b}) => b - a);

            }).catch(err => {
              console.error(err);
            });
          }

          const getAnniFattureConservazione = () => {

            ArchiSmallServices
              .getStorageUsageClassDocEmailYears(emailcli, [])
              .then(response => {
                $scope.classDocPec = (JSON.parse(JSON.stringify(response)) as IStorageUsageClassDocStatistics[]).filter(item => item.docClass === 'pec_posta_elettronica_certificata' || item.docClass === 'pec_notifiche_pec');
                if ($scope.classDocPec.length > 0) {
                  $scope.consumiPec = $scope.classDocPec.sort(({year: a}, {year: b}) => (b - a));
                  $scope.consumoTotalePec = parseFloat(((($scope.consumiPec.reduce((prev, curr) => prev + curr.size, 0)) / Math.pow(1024, 2))).toFixed(2));
                } else {
                  $scope.consumiPec = [];
                  $scope.consumoTotalePec = 0;
                }

              }).catch(err => {
              console.error(err);
            });
          };

          myPromiseFatture().then(() =>
            getAnniFattureConservazione()
          );

          $scope.refreshSedeStates();
          $scope.refreshCities();

        });
    };

    $scope.setFormattedSize = (item) => {
      if (item >= 1000) {
        $scope.storageCE = (`${(item / 1024).toFixed(2)} GB`);
      } else {
        $scope.storageCE = `${item.toFixed(2)} MB`;
      }
    };

    $scope.getConsumoConservazioneAnno = (year: any) => {
      let sum = 0;
      for (let i = 0; i < $scope.consumiConservazioneList.length; i++) {
        if ($scope.consumiConservazioneList[i].year === year) {
          sum += parseFloat(($scope.consumiConservazioneList[i].storageUsageInBytes / Math.pow(1024, 2)).toFixed(2));
        }
      }
      return sum;
    };
    $scope.getConsumoSpazioPecAnno = (year: number) => {
      let sum = 0;

      for (let i = 0; i < $scope.consumiPec.length; i++) {
        if ($scope.consumiPec[i].year === year) {
          sum += parseFloat(($scope.consumiPec[i].size / Math.pow(1024, 2)).toFixed(2));
        }
      }
      return sum;
    };

    $scope.getConsumoArchiviaAnno = (year: number) => {
      let sum = 0;

      for (let i = 0; i < $scope.consumiArchiviaList.length; i++) {
        if ($scope.consumiArchiviaList[i].year === year) {
          sum += parseFloat(($scope.consumiArchiviaList[i].size / Math.pow(1024, 2)).toFixed(2));
        }
      }
      return sum;
    };


    $scope.getUsersTypeaheadValues();

    $scope.refreshResults = ($select) => {
      UISelectService.refreshResults($select);
    };

    $scope.soloConsultazione = () => {
      $scope.solo_consultazione = !$scope.solo_consultazione;
      $scope.can_use_fatturazione = !$scope.solo_consultazione;
      $scope.can_use_conservazione = !$scope.solo_consultazione;
      $scope.user.subscription.readOnly = $scope.solo_consultazione;
    };

    $scope.enableCheckLimits = () => {

      $scope.isRequired = !$scope.user.isCheckLimits;
      $scope.user.isBlockUser = false;
      $scope.user.emailSentThresholdSurpassed = {
        'CE': false,
        'FE': false,
        'PEC': false
      };
      $scope.user.emailSentLimitSurpassed = {
        'CE': false,
        'FE': false,
        'PEC': false
      };
      $scope.user.contactEmailAlert = '';
      $scope.user.contactEmailAlertCC = '';

    };

    $scope.downloadContratto = () => {
      this.fileService.downloadFile(`${STORAGE_BUCKET}/${$scope.user.accountData.email}/personal_files/contract/Contratto-ArchiSMALL.pdf`);
    };


    $scope.changeListino = (arg: IListini) => {

      ArchiSmallServices.getListini().then(
        response => {
          const listini = JSON.parse(JSON.stringify(response)) as IListini[];
          $scope.listino = listini.find(item => item._id === arg._id);
        }
      );

      $scope.codProfiloCE = undefined;
      $scope.codProfiloFE = undefined;
      $scope.codProfiloPEC = undefined;

      $scope.limitProfileCE = undefined;
      $scope.limitProfileFE = undefined;
      $scope.limitProfilePEC = undefined;

    };

    $scope.changeCodProfiloFE = (arg: IProfile) => {
      $scope.codProfiloFE = arg;
      $scope.limitProfileFE = arg.limit;
    };
    $scope.changeCodProfiloCE = (arg: IProfile) => {
      $scope.codProfiloCE = arg;
      $scope.limitProfileCE = arg.limit;
    };
    $scope.changeCodProfiloPEC = (arg: IProfile) => {
      $scope.codProfiloPEC = arg;
      $scope.limitProfilePEC = arg.limit;
    };


    $scope.exportDataXLS = () => {

      var htmlTable = document.getElementById('tableToExport').outerHTML;

      var fileContent = `
    <html xmlns:o="urn:schemas-microsoft-com:office:office"
    xmlns:x="urn:schemas-microsoft-com:office:excel"
    xmlns="http://www.w3.org/TR/REC-html40">
    <head><!--[if gte mso 9]>
    <xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>
    <x:Name>Sheet1</x:Name>
    <x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions>
    </x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml>
    <![endif]--></head>
    <body>
    ${htmlTable}
    </body>
    </html>`;

      var blob = new Blob([fileContent], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
      });

      saveAs(blob, 'ReportTabellaConsumi.xls');

    };

    $scope.openConfermaModal = (size) => {

      const user = $scope.originalUser;

      if ($scope.scadenza.value.getTime() > user.subscription.subscriptionEnd) {
        delete user.subscription.subscriptionCancelledDate;
        user.subscription.subscriptionCancelled = false;
        user.subscription.subscription_expired = false;
        user.subscription.renew_request = false;
        user.subscription.expire_notify_days = '';
      }

      if ($scope.dati.dsExpireDate && user.digitalSign) {
        user.digitalSign.expireDate = $scope.dati.dsExpireDate;
      }

      // dati sede
      if (user.organizationData.address !== undefined && user.organizationData.address !== $scope.user.organizationData.address) {
        user.organizationData.address = $scope.user.organizationData.address;
      }
      if (user.organizationData.numeroCivico !== undefined && user.organizationData.numeroCivico !== $scope.user.organizationData.numeroCivico) {
        user.organizationData.numeroCivico = $scope.user.organizationData.numeroCivico;
      }
      if (user.organizationData.codicePaese !== undefined && user.organizationData.codicePaese !== $scope.user.organizationData.codicePaese) {
        user.organizationData.codicePaese = $scope.user.organizationData.codicePaese;
      }
      if (user.organizationData.province !== undefined && user.organizationData.province !== $scope.user.organizationData.province) {
        user.organizationData.province = $scope.user.organizationData.province;
      }
      if (user.organizationData.city !== undefined && user.organizationData.city !== $scope.user.organizationData.city) {
        user.organizationData.city = $scope.user.organizationData.city;
      }
      if (user.organizationData.CAP !== undefined && user.organizationData.CAP !== $scope.user.organizationData.CAP) {
        user.organizationData.CAP = $scope.user.organizationData.CAP;
      }
      // rappresentante legale
      if (user.organizationData.contactPerson.firstname !== undefined && user.organizationData.contactPerson.firstname !== $scope.user.organizationData.contactPerson.firstname) {
        user.organizationData.contactPerson.firstname = $scope.user.organizationData.contactPerson.firstname;
      }
      if (user.organizationData.contactPerson.surname !== undefined && user.organizationData.contactPerson.surname !== $scope.user.organizationData.contactPerson.surname) {
        user.organizationData.contactPerson.surname = $scope.user.organizationData.contactPerson.surname;
      }
      if (user.organizationData.contactPerson.fiscalCode !== undefined && user.organizationData.contactPerson.fiscalCode !== $scope.user.organizationData.contactPerson.fiscalCode) {
        user.organizationData.contactPerson.fiscalCode = $scope.user.organizationData.contactPerson.fiscalCode;
      }
      if (!new Date(user.organizationData.contactPerson.birthDate).toLocaleDateString().includes($scope.dati.data_nascita_rf.toLocaleDateString())) {
        user.organizationData.contactPerson.birthDate = $scope.dati.data_nascita_rf.toISOString();
      }

      // responsabile conservazione
      if (user.organizationData.responsabileConservazione.firstName !== undefined && user.organizationData.responsabileConservazione.firstName !== $scope.originalUser.organizationData.responsabileConservazione.firstName) {
        user.organizationData.responsabileConservazione.firstName = $scope.originalUser.organizationData.responsabileConservazione.firstName;
      }
      if (user.organizationData.responsabileConservazione.surName !== undefined && user.organizationData.responsabileConservazione.surName !== $scope.originalUser.organizationData.responsabileConservazione.surName) {
        user.organizationData.responsabileConservazione.surName = $scope.originalUser.organizationData.responsabileConservazione.surName;
      }
      if (user.organizationData.responsabileConservazione.fiscalCode !== undefined && user.organizationData.responsabileConservazione.fiscalCode !== $scope.originalUser.organizationData.responsabileConservazione.fiscalCode) {
        user.organizationData.responsabileConservazione.fiscalCode = $scope.originalUser.organizationData.responsabileConservazione.fiscalCode;
      }
      if (user.organizationData.responsabileConservazione.birthDate !== undefined && user.organizationData.responsabileConservazione.birthDate !== $scope.originalUser.organizationData.responsabileConservazione.birthDate) {
        user.organizationData.responsabileConservazione.birthDate = $scope.originalUser.organizationData.responsabileConservazione.birthDate;
      }

      if ($scope.user.useResponConserv === false) {
        user.organizationData.responsabileConservazione.firstName = undefined;
        user.organizationData.responsabileConservazione.surName = undefined;
        user.organizationData.responsabileConservazione.fiscalCode = undefined;
        user.organizationData.responsabileConservazione.birthDate = undefined;

      }
      // dati account
      if ($scope.dati.email !== undefined && !$scope.dati.email.includes(user.accountData.email)) {
        if (!user.accountData.oldEmails) {
          user.accountData.oldEmails = [];
        }
        // email cambiata, aggiungi vecchia a lista e cambia con nuova
        user.accountData.oldEmails.push(user.accountData.email);
        user.accountData.email = $scope.dati.email;
      }

      if ($scope.dati.firstName !== undefined && !$scope.dati.firstName.includes(user.accountData.firstName)) {
        user.accountData.firstName = $scope.dati.firstName;
      }
      if ($scope.dati.lastName !== undefined && !$scope.dati.lastName.includes(user.accountData.lastName)) {
        user.accountData.lastName = $scope.dati.lastName;
      }
      if ($scope.dati.fiscalCode !== undefined && !$scope.dati.fiscalCode.includes(user.accountData.fiscalCode)) {
        user.accountData.fiscalCode = $scope.dati.fiscalCode;
      }

      // altri dati
      // cambio nome e cognome
      if (user.organizationData.name === undefined || user.organizationData.name === '') {
        if ($scope.dati.nome !== undefined && $scope.dati.nome !== user.organizationData.contactPerson.firstname) {
          user.organizationData.contactPerson.firstname = $scope.dati.nome;
        }
        if ($scope.dati.cognome !== undefined && $scope.dati.cognome !== user.organizationData.contactPerson.surname) {
          user.organizationData.contactPerson.surname = $scope.dati.cognome;
        }
      }
      // cambio ragione sociale
      if ($scope.dati.ragione_sociale !== undefined && $scope.dati.ragione_sociale !== user.organizationData.name) {
        user.organizationData.name = $scope.dati.ragione_sociale;
      }
      // cambio piva e cf
      if ($scope.dati.piva !== undefined && $scope.dati.piva !== user.organizationData.PIVA) {
        user.organizationData.PIVA = $scope.dati.piva;
      }
      if ($scope.dati.cf !== undefined && $scope.dati.cf !== user.organizationData.fiscalCode) {
        user.organizationData.fiscalCode = $scope.dati.cf;
      }
      // cambio codice attivazione / partner
      if ($scope.dati.codice.length > 23) {
        [ActivationCode.PROFILE, ActivationCode.RESELLER, ActivationCode.FE, ActivationCode.CE, ActivationCode.COD_RANDOM] = $scope.dati.codice.split('-');
      } else {
        [ActivationCode.PROFILE, ActivationCode.RESELLER, ActivationCode.FE, ActivationCode.COD_RANDOM] = $scope.dati.codice.split('-');
      }
      if ($scope.dati.codice !== undefined && ($scope.listino.code !== ActivationCode.PROFILE || $scope.user.reseller.code !== ActivationCode.PROFILE || $scope.codProfiloFE.code !== ActivationCode.FE || $scope.codProfiloCE.code !== ActivationCode.CE)) {
        let [PROFILO, RIVENDITORE, FATTURAZIONE, CONSERVAZIONE, COD_RANDOM] = $scope.dati.codice.split('-');

        PROFILO = $scope.listino.code;
        RIVENDITORE = $scope.user.reseller.code;
        FATTURAZIONE = $scope.codProfiloFE.code;
        CONSERVAZIONE = $scope.codProfiloCE.code;
        COD_RANDOM = ActivationCode.COD_RANDOM;

        user.reseller = $scope.user.reseller;
        user.subscription.activationCode = `${PROFILO}-${RIVENDITORE}-${FATTURAZIONE}-${CONSERVAZIONE}-${COD_RANDOM}`;
      }

      // cambio codice listino
      if (($scope.listino && $scope.listino._id) !== user.licenseProfile.licenseId) {
        user.licenseProfile.licenseId = $scope.listino ? $scope.listino._id : undefined;
      }

      // cambio codici profili listini: FE, CE, PEC
      if (($scope.user.licenseProfile.profileCode !== user.licenseProfile.profileCode) || $scope.user.licenseProfile.profileCode === undefined) {
        if (user.licenseProfile.profileCode === undefined || user.licenseProfile.profileCode === null) {
          user.licenseProfile.profileCode = {
            FE: undefined,
            CE: undefined,
            PEC: undefined,
          };
        }

        user.licenseProfile.profileCode[Limit.FE] = $scope.codProfiloFE;
        user.licenseProfile.profileCode[Limit.CE] = $scope.codProfiloCE;
        user.licenseProfile.profileCode[Limit.PEC] = $scope.codProfiloPEC;

      }

      if ($scope.user.limits.maxStorageSizeMB !== undefined && $scope.user.limits.maxStorageSizeMB !== user.limits.maxStorageSizeMB) {
        user.limits.maxStorageSizeMB = $scope.user.limits.maxStorageSizeMB;
      }

      if ($scope.user.canUseArchiSync !== undefined && $scope.user.canUseArchiSync !== user.canUseArchiSync) {
        user.canUseArchiSync = $scope.user.canUseArchiSync;
      }
      if ($scope.user.canUseArchiPro !== undefined && $scope.user.canUseArchiPro !== user.canUseArchiPro) {
        user.canUseArchiPro = $scope.user.canUseArchiPro;
      }

      user.subscription.subscriptionEnd = $scope.scadenza.value.getTime();
      user.canUseFatturaPA = $scope.can_use_fatturazione;
      user.canUseConservazione = $scope.can_use_conservazione;
      user.isCheckLimits = $scope.user.isCheckLimits;
      user.isBlockUser = $scope.user.isBlockUser;
      user.contactEmailAlert = $scope.user.contactEmailAlert;
      user.contactEmailAlertCC = $scope.user.contactEmailAlertCC;
      user.useResponConserv = $scope.user.useResponConserv;
      user.emailSentThresholdSurpassed = $scope.user.emailSentThresholdSurpassed;
      user.emailSentLimitSurpassed = $scope.user.emailSentLimitSurpassed;
      user.subscription.readOnly = $scope.user.subscription.readOnly;
      user.subscription.cancellationRequest = $scope.user.subscription.cancellationRequest;

      user.last_differences = JSON.stringify({...diff($scope.user, user)});

      let ConfermaModal = $uibModal.open({
        animation: true,
        component: 'confermaComponent',
        size: size,
        windowClass: 'center-modal',
        backdrop: 'static',
        keyboard: false,
        resolve: {
          user: () => {
            return user;
          },
          otherUpdate: true,
          diffs: () => {
            return user.last_differences;
          }
        }
      });

      setTimeout($scope.getUsersTypeaheadValues, 3000);

      $scope.user = undefined;
      $scope.consumi = undefined;
      $scope.scadenza = {value: undefined};
      $scope.can_use_fatturazione = false;
      $scope.can_use_conservazione = false;
      $scope.dataAttivazione = undefined;
      $scope.fatture = [];
      $scope.dati = {
        piva: undefined,
        cf: undefined,
        ragione_sociale: undefined,
        email: undefined,
        nome: undefined,
        cognome: undefined,
        codice: undefined,
        data_nascita_rf: undefined,
        dsExpireDate: undefined,
        firstName: undefined,
        lastName: undefined,
        fiscalCode: undefined,
      };
    };
  }
}

export const ModificaClienteComponent: ng.IComponentOptions = {
  template: require('./modifica-cliente.html'),
  controller: ModificaClienteController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/admin/scheda-clienti/modifica-cliente/modifica-cliente.ts